import axios from 'axios'
import formatDateForBackend from '../../../utils/formatDateForBackend'
import formatTimeForBackend from '../../../utils/formatTimeForBackend'

export default {
  namespaced: false,
  state: {
    allPrices: {},
    firstFetchDone: false,
  },
  mutations: {
    SET_PRICES(state, prices) {
      state.allPrices = prices
    },
    SET_FIRST_PRICE_FETCH_DONE_TRUE(state) {
      state.firstFetchDone = true
    },
  },
  getters: {
    canGetPrices(state, getters, rootState, rootGetters) {
      return rootGetters['booking/datesAndBusinessReady']
    },
    dataForPrices(state, getters, rootState) {
      const { booking } = rootState
      if (!getters.canGetPrices) {
        return
      }
      return {
        departure_business_id: booking.pickUp.business.id,
        return_business_id: !booking.oneway ? booking.pickUp.business.id : booking.drop.business && booking.drop.business.id,
        departure_date: formatDateForBackend(booking.pickUp.date),
        return_date: formatDateForBackend(booking.drop.date),
        departure_time: formatTimeForBackend(booking.pickUp.time),
        return_time: formatTimeForBackend(booking.drop.time),
        is_rent_plus: false,
        rent_plus_discount_level: null,
        kilometers: null,
        coupon: null,
      }
    },
    getPlan: (state, getters, rootState) => (vehiculeSemiClair) => {
      const vehiclePriceInfo = rootState.vehicles.prices.allPrices[vehiculeSemiClair]
      return vehiclePriceInfo && vehiclePriceInfo.plan
    },
  },
  actions: {
    GET_PRICES({
      state, commit, rootState, getters,
    }) {
      if (!rootState.rrsAvailable || state.firstFetchDone) {
        return
      }
      commit('SET_FIRST_PRICE_FETCH_DONE_TRUE')
      axios.post(`${rootState.api}/vehicles/prices`, getters.dataForPrices).then((res) => {
        commit('SET_PRICES', res.data.data)
        state.firstFetchDone = false
      })
    },
  },
}
